module.exports = __webpack_public_path__ + "img/pago_comision.95b3e041.svg";